import { render } from "./AddProductToCartRestrictedModal.vue?vue&type=template&id=99a083ce"
import script from "./AddProductToCartRestrictedModal.vue?vue&type=script&lang=js"
export * from "./AddProductToCartRestrictedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__